module.exports = __webpack_public_path__ + "img/app_new_main_3.461b3ba0.jpg";